/**
 * Auto-generated by Style Dictionary from DTCG tokens.
 * DO NOT EDIT — run `nx run tokens:code` to regenerate.
 *
 * @generated
 */

export const shadow = {
  elevation0: 'none',
  elevation1: 'none',
  elevation10: 'none',
  elevation11: 'none',
  elevation12: 'none',
  elevation13: 'none',
  elevation14: 'none',
  elevation15: 'none',
  elevation16: 'none',
  elevation17: 'none',
  elevation18: 'none',
  elevation19: 'none',
  elevation2: 'none',
  elevation20: 'none',
  elevation21: 'none',
  elevation22: 'none',
  elevation23: 'none',
  elevation3: 'none',
  elevation4: 'none',
  elevation5: 'none',
  elevation6: 'none',
  elevation7: 'none',
  elevation8: 'none',
  elevation9: 'none',
} as const;
